export const anchorClass = 'dds-anchor'
